import { ColorScheme } from '../../types/bitkit';

const schemeColors: Record<ColorScheme, any> = {
  blue: {
    _active: {
      backgroundColor: 'blue.90',
    },
    _hover: {
      backgroundColor: 'blue.93',
    },
    color: 'blue.40',
  },
  green: {
    _active: {
      backgroundColor: 'green.90',
    },
    _hover: {
      backgroundColor: 'green.93',
    },
    color: 'green.40',
  },
  neutral: {
    _active: {
      backgroundColor: 'rgba(255, 255, 255, 0.3)',
    },
    _hover: {
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
    },
    color: 'neutral.100',
  },
  orange: {
    _active: {
      backgroundColor: 'orange.90',
    },
    _hover: {
      backgroundColor: 'orange.93',
    },
    color: 'orange.40',
  },
  purple: {
    _active: {
      backgroundColor: 'purple.90',
    },
    _hover: {
      backgroundColor: 'purple.93',
    },
    color: 'purple.40',
  },
  red: {
    _active: {
      backgroundColor: 'red.90',
    },
    _hover: {
      backgroundColor: 'red.93',
    },
    color: 'red.40',
  },
  yellow: {
    _active: {
      backgroundColor: 'yellow.90',
    },
    _hover: {
      backgroundColor: 'yellow.93',
    },
    color: 'yellow.40',
  },
};

const ColorButtonTheme = {
  baseStyle: ({ colorScheme }: { colorScheme?: ColorScheme }) => {
    return {
      alignItems: 'center',
      backgroundColor: 'transparent',
      display: 'inline-flex',
      justifyContent: 'center',
      borderColor: 'inherit',
      ...schemeColors[colorScheme || 'blue'],
    };
  },
};

export default ColorButtonTheme;
